export default __webpack_public_path__ + "static/media/contact.6f15e722.svg";